/**
 * Puts every onboarding step on disk the moment it happens.
 *
 * redux-persist stages one whitelisted key per throttle tick, so the first
 * write after boot lands roughly (whitelist length × throttle) later: about
 * sixteen seconds with the root config. A cook who answers the three duels
 * and reloads inside that window would start over. The `(app)` layout flushes
 * on tab hide, but the onboarding routes live outside that group, so the quiz
 * had no flush at all.
 *
 * The flush is registered by store.ts rather than imported, because store.ts
 * imports this file (same pattern as `registerPersistFlush`).
 */
import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import {
  startOnboarding,
  answerQuestion,
  confirmSafety,
  setGeneratedWeek,
  chooseDirection,
  dismissReadingCard,
  completeOnboarding,
} from './onboardingSlice';
import { setAllergens, setTasteAxes, flipTasteAxis, setDefaultFamilySize } from './userPreferencesSlice';

let flush: (() => unknown) | null = null;

export const registerOnboardingPersistFlush = (fn: () => unknown): void => {
  flush = fn;
};

export const onboardingPersistMiddleware = createListenerMiddleware();

export const isOnboardingStep = isAnyOf(
  startOnboarding,
  answerQuestion,
  confirmSafety,
  setGeneratedWeek,
  chooseDirection,
  dismissReadingCard,
  completeOnboarding,
  setAllergens,
  setTasteAxes,
  flipTasteAxis,
  setDefaultFamilySize,
);

onboardingPersistMiddleware.startListening({
  matcher: isOnboardingStep,
  effect: () => {
    void flush?.();
  },
});
